import { FC } from "react"
import { Layers } from "lucide-react"
import { Integration } from "../../../../../types"
import SectionCard from "../../../section-card"
import { EmbedsOptions } from "../../fields"

interface Props {
  integration?: Integration
  title?: string
}

const EmbedTypeSection: FC<Props> = ({ integration, title }) => (
  <SectionCard icon={<Layers size={15} />} title={title ?? "Embed Type"}>
    <EmbedsOptions integration={integration} />
  </SectionCard>
)

export default EmbedTypeSection
